<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 mat-dialog-title>Create new segment</h1>
<div mat-dialog-content>
  <fab-loading-spinner color="primary" *ngIf="showSpinner"></fab-loading-spinner>
  <form [formGroup]="segmentForm">

    <mat-form-field>
      <mat-label>Segment</mat-label>
      <mat-hint>Required</mat-hint>
      <input matInput maxlength="21" id="segment-input" formControlName="segment"/>
    </mat-form-field>
    <br/>

    <mat-form-field>
      <mat-label>Vehicle Type</mat-label>
      <mat-select id="vehicle-type" formControlName="vehicleType">
        <mat-option *ngFor="let type of vehicleTypes" [value]="type">
          {{type}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br/>
    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" id="submit-button" (click)="onSubmit()" [disabled]="!segmentForm.valid">
        Create
      </button>
    </div>

  </form>

</div>
